<script>
    import { mapGetters } from "vuex";

    export default {
        name: "BasePrice",
        props: {
            price: [Number, String],
        },
        computed: {
            ...mapGetters("Root", ["currency"]),
        },
    };
</script>

<template>
    <span class="base-price">
        {{ price | formatPrice }}&nbsp;<span class="base-price__currency">{{ currency }}</span>
    </span>
</template>

<style lang="scss"></style>
